import { SVGProps } from 'react';

interface UploadIconProps extends SVGProps<SVGSVGElement> {
  invertColors?: boolean;
}

export const UploadIcon = ({ invertColors, ...props }: UploadIconProps): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.75 9.75977V14.1035C14.75 14.4482 14.4697 14.7285 14.125 14.7285H1.875C1.53038 14.7285 1.25 14.4482 1.25 14.1035V9.75977H0V14.1035C0 15.1374 0.841127 15.9785 1.875 15.9785H14.125C15.1589 15.9785 16 15.1374 16 14.1035V9.75977H14.75Z"
      fill={invertColors ? 'white' : 'black'}
    />
    <path
      d="M7.99912 0L4.11523 3.88388L4.99911 4.76776L7.37412 2.39276V12.1339H8.62412V2.39276L10.9991 4.76776L11.883 3.88388L7.99912 0Z"
      fill={invertColors ? 'white' : 'black'}
    />
  </svg>
);
